export default {"src":"/landings/_next/static/media/Icons.59197d12.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};